<script lang="ts">
  import { ArtistPage } from '@pages/artist';

  import type { PageData } from './$types';

  export let data: PageData;
</script>

<ArtistPage
  artist="{data.artist}"
  artworks="{data.artworks}"
  pageNumber="{data.artworksPage}"
  loadMore="{data.artworksLoadMore}"
  auctions="{data.auctions}"
  artworksCount="{data.artworksCount}"
  auctionsCount="{data.auctionsCount}"
  form="{data.form}"
  hasParams="{data.hasParams}"
/>
